import { FC, useState } from 'react';
import { SearchSelectInput } from 'components/core';
// import { usePaymentMethods } from 'pages/wallet/hooks/use-payment-methods';
import { useSupportedProviders } from 'pages/wallet/hooks/use-payment-methods';
import { useCurrentUser } from '_graphql/cache/auth';
import {
  CountryCode,
  PaystackGhanaBankType,
} from '_graphql/__generated__/globalTypes';

interface PaymentMethodPickerProps {
  id: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  setFieldTouched: any;
  setFieldError: any;
  rawId?: boolean;
  clearAfterSelect?: string[];
}

const PaymentMethodPicker: FC<PaymentMethodPickerProps> = ({
  id,
  label,
  rawId,
  clearAfterSelect,
  ...form
}) => {
  // const { loading, methods } = usePaymentMethods({
  //   fetchPolicy: 'network-only',
  // });

  const [provider, setProvider] = useState<PaystackGhanaBankType.mobile_money>(
    PaystackGhanaBankType.mobile_money
  );

  const user = useCurrentUser();

  const { providers, loading } = useSupportedProviders({
    variables: {
      input: {
        country: user?.country as CountryCode,
        filter: {
          country: user?.country as CountryCode,
          type: provider,
        },
      },
    },
  });

  return (
    <div className="grid gap-3">
      {user?.country === 'GH' && (
        <div className="grid gap-1">
          <label className="block text-sm font-medium text-gray-700">
            Select Provider
          </label>
          <select
            onChange={(e) => [
              setProvider(e.target.value as any),
              form.setFieldValue('providerType', e.target.value),
            ]}
            className="focus:ring-primary-500 focus:border-primary-500 border-gray-300 shadow-sm block w-full sm:text-sm rounded-md placeholder:font-light placeholder:text-xs h-[38px]"
          >
            <option value="">Select Option</option>
            <option value={PaystackGhanaBankType.mobile_money}>
              Mobile Money
            </option>
            <option value={PaystackGhanaBankType.ghipps}>Bank</option>
          </select>
        </div>
      )}
      <SearchSelectInput
        id={id ?? 'payment-method'}
        label={label ?? 'Payment Method'}
        placeholder="Select Payment Method"
        optionsLoading={loading}
        handdleFinishedOnChange={() => {
          clearAfterSelect?.forEach((field) => {
            form.setFieldValue(field, '');
          });
        }}
        options={(providers ?? [])?.map((activity: any) => ({
          label: {
            title: activity.name as string,
          },
          value: rawId ? activity?.code : activity,
        }))}
        {...form}
        disabled={form.disabled}
      />
    </div>
  );
};

export default PaymentMethodPicker;
